import React from 'react';
import { connect } from 'react-redux';
import {
  Field,
  reduxForm,
  getFormValues,
  FieldArray,
  change,
} from 'redux-form';
import LabelSection from 'components/sections/LabelSection';
import { Link } from 'react-router';
import {
  onClickAddIngredients,
  recipesFormOnChangeOutlet,
  recipesFormOnClickCancel,
  addItemVariantOnChangeItems,
  showDeleteModal,
  hideDeleteModal,
  deleteRecipes,
  setIngredientByItemVariant,
  unSetIngredientByItemVariant,
} from 'actions/ingredients/recipes';
import SettingField from 'components/Fields/ReduxForm/SettingField';
import Select from 'react-select';
import LibraryDeleteModal from 'components/LibraryDeleteModal';
import { currencyFormatter } from 'utils/formatter';
import ConfirmSubmitModal from './ConfirmSubmitModal';
import styles from './RecipesForm.css';

const validate = values => {
  const errors = {};
  const recipesErrors = [];
  if (values.recipe_ingredients) {
    values.recipe_ingredients.forEach((member, index) => {
      const memberErrors = {};
      if (!member.quantity && `${member.quantity}` !== '0') {
        memberErrors.quantity = 'The quantity is required';
        recipesErrors[index] = memberErrors;
      } else if (member.quantity > 999999999.99) {
        memberErrors.quantity = 'Quantity must be less than 999999999.99';
        recipesErrors[index] = memberErrors;
      } else if (parseFloat(member.quantity) < 0.01) {
        memberErrors.quantity = 'Quantity must be greater than 0.01';
        recipesErrors[index] = memberErrors;
      }
    });
  }
  if (recipesErrors.length) {
    errors.recipe_ingredients = recipesErrors;
  }
  return errors;
};

const normalizeNumber = (value = 0, previousValue) => {
  if (value === '') {
    return value;
  }
  if (!isNaN(value)) {
    return value;
  }
  return previousValue;
};

const renderFieldArrayIngredients = ({
  fields,
  dispatch,
  recipeIngredients,
}) => {
  const doms = [];
  fields.map(function(member, index) {
    const cogsTracked =
      recipeIngredients.length && recipeIngredients[index].track_cogs;
    doms.push(
      <div
        key={index}
        className={`col-md-12 ${styles['box-ingredient-recipes']}`}
      >
        <div className="mk-grouped-input">
          <div className="form-group col-sm-3">
            <Field
              name="ingredient_id"
              component="input"
              readOnly
              className={`form-control hidden`}
              type="hidden"
              disabled
            />
            <Field
              name={`${member}.ingredient_name`}
              component="input"
              readOnly
              className={`form-control ${styles.grey_box}`}
              disabled
            />
          </div>
          <div className="form-group col-sm-3">
            <Field
              component={SettingField}
              positiveNumberOnly
              maxFractionDigits={2}
              className={`form-control`}
              name={`${member}.quantity`}
              placeholder="0.00"
              normalize={normalizeNumber}
              onChange={(event, value) => {
                let quantity = parseFloat(value);
                quantity = !isNaN(quantity) ? quantity : null;
                dispatch(change('recipes', `${member}.quantity`, quantity));
                if (cogsTracked) {
                  dispatch(
                    change(
                      'recipes',
                      `${member}.ingredient_avg`,
                      recipeIngredients[index].cogs * quantity
                    )
                  );
                }
                return value;
              }}
            />
          </div>
          <div className="form-group col-sm-3">
            <Field
              component="input"
              className={`form-control ${styles.grey_box}`}
              name={`${member}.unit_name`}
              disabled
              placeholder="Unit Name"
            />
            <Field
              component="input"
              className={`form-control ${styles.grey_box}`}
              name={`${member}.unit_id`}
              placeholder="unit"
              disabled
              type="hidden"
            />
          </div>

          <div className="form-group col-sm-3">
            <Field
              component="input"
              className={`form-control ${styles.grey_box}`}
              name={`${member}.ingredient_avg`}
              disabled
              placeholder={cogsTracked ? 'Rp. 0' : ''}
              format={value => (cogsTracked ? currencyFormatter(value) : '')}
            />
            <span
              onClick={() => {
                fields.remove(index);
              }}
              className={styles['btn-delete-wrapper']}
            >
              <i className="fa fa-times-circle" />
            </span>
          </div>
        </div>
      </div>
    );
  });
  return (
    <div
      className={`row mk-grouped-list-input ${styles['recipes-item-wrapper']}`}
    >
      {fields.length ? (
        <div className={`col-md-12`}>
          <div className={`col-md-3 text-center ${styles.recipes_header}`}>
            Ingredient
          </div>
          <div className={`col-md-3 text-center ${styles.recipes_header}`}>
            Quantity
          </div>
          <div className={`col-md-3 text-center ${styles.recipes_header}`}>
            Unit
          </div>
          <div className={`col-md-3 text-center ${styles.recipes_header}`}>
            Avg Cost
          </div>
        </div>
      ) : (
        ''
      )}
      {doms}
      {fields.length ? (
        <div className="col-md-12 mt-20px">
          <div className="col-md-9 text-left no-padding">TOTAL AVG COST</div>
          <div className={`col-md-3 text-left ${styles.padding_left_avg_cost}`}>
            {currencyFormatter(totalAvgCost(recipeIngredients))}
          </div>
        </div>
      ) : (
        ''
      )}
    </div>
  );

  function totalAvgCost(recipeIngredients) {
    let total = 0;
    recipeIngredients.forEach(ing => {
      if (ing.ingredient_avg) {
        total += ing.ingredient_avg;
      }
    });
    return total;
  }
};

const formatIngredientInStock = ({
  input: { value },
  placeholder,
  className,
}) => {
  return (
    <input
      value={value}
      className={
        className ? `form-control ${className.className}` : 'form-control'
      }
      placeholder={placeholder}
      disabled
    />
  );
};

const renderFieldArrayInventory = ({ fields, recipeIngredients }) => {
  const doms = [];
  let lowStock = 0;
  let outStock = 0;
  const result = [];
  $.each(recipeIngredients, function(i, ingredient) {
    lowStock = 0;
    outStock = 0;
    if (
      ingredient.alert &&
      ingredient.in_stock > 0 &&
      ingredient.in_stock <= ingredient.stock_alert
    )
      lowStock += 1;
    if (ingredient.alert && ingredient.in_stock <= 0) outStock += 1;
    if (lowStock > 0) {
      result.push({ className: 'stockAllertLow' });
    } else if (outStock > 0) {
      result.push({ className: 'stockAllertOut' });
    } else {
      result.push({ className: '' });
    }
  });
  fields.map(function(member, index) {
    doms.push(
      <div
        key={index}
        className={`col-md-12 ${styles['box-ingredient-recipes']}`}
      >
        <div className="mk-grouped-input">
          <div className="form-group col-sm-4">
            <Field
              component="input"
              className={`form-control`}
              name={`${member}.ingredient_name`}
              disabled
              placeholder="Name"
            />
          </div>
          <div className="form-group col-sm-4">
            <Field
              component={formatIngredientInStock}
              className={result[index]}
              name={`${member}.in_stock`}
              placeholder="0"
            />
          </div>
          <div className="form-group col-sm-4">
            <Field
              component="input"
              className={`form-control`}
              name={`${member}.unit_name`}
              disabled
              placeholder="Unit Name"
            />
          </div>
        </div>
      </div>
    );
  });
  return (
    <div
      className={`row mk-grouped-list-input ${styles['recipes-item-wrapper']}`}
    >
      {fields.length ? (
        <div className={`col-md-12`}>
          <LabelSection title="INVENTORY" />
          <div className={`col-md-4 text-center ${styles.recipes_header}`} />
          <div className={`col-md-4 text-left ${styles.recipes_header}`}>
            In Stock
          </div>
          <div className={`col-md-4 text-center ${styles.recipes_header}`} />
        </div>
      ) : (
        ''
      )}
      {doms}
    </div>
  );
};

const renderSelectFieldWithoutCreate = ({
  input: { value, onChange, disabled },
  placeholder,
  options,
}) => {
  const onChangeSelect = newval => {
    onChange(newval.value);
  };
  return (
    <Select
      value={value}
      name="itemsDropdownObj"
      className="itemsDropdownObj"
      placeholder={placeholder}
      onChange={onChangeSelect}
      options={options}
      clearable={false}
      disabled={disabled}
    />
  );
};

class RecipesForm extends React.Component {
  render() {
    const {
      itemsDropdowns,
      itemVariant,
      recipesDetail,
      recipesForm,
      showDeleteModal,
      handleSubmit,
      isSubmittingForm,
      outlets,
    } = this.props;
    return (
      <form className={styles.wrapper} onSubmit={handleSubmit}>
        <div className={`${styles['form-content']} recipes-form-content`}>
          <LabelSection title="CHOOSE ITEM" />
          <Field
            name="id"
            component="input"
            readOnly
            className={`form-control hidden`}
            type="hidden"
            disabled
          />
          <Field
            name="sku"
            component="input"
            readOnly
            className={`form-control hidden`}
            type="hidden"
            disabled
          />
          <div className="form-group">
            {recipesDetail ? (
              <Field
                name="item_name"
                component="input"
                disabled
                className={`form-control`}
              />
            ) : (
              <Field
                component={renderSelectFieldWithoutCreate}
                className={`item_id ${!recipesDetail && 'hidden'}`}
                name="item_id"
                options={itemsDropdowns}
                onChange={this._onChangeSelectDropdown}
                placeholder="Select an Item"
                clearable={false}
                disabled={recipesDetail && recipesDetail.id}
                hidden={!recipesDetail}
              />
            )}
          </div>
          <LabelSection title="CHOOSE VARIANT" />
          <div className="form-group">
            {recipesDetail ? (
              <div>
                <Field
                  name="item_variant_name"
                  component="input"
                  disabled
                  value={recipesDetail.item_variant_name}
                  className="form-control"
                />
                <Field
                  name="item_variant_id"
                  component="input"
                  readOnly
                  className={`form-control hidden`}
                  type="hidden"
                  disabled
                  value={recipesDetail.item_variant_id}
                />
              </div>
            ) : (
              <Field
                name="item_variant_id"
                component="select"
                onChange={this._onChangeVariant.bind(this, itemVariant)}
                className="form-control item-variant-select"
                disabled={
                  (itemVariant && itemVariant.length <= 1) ||
                  (recipesDetail && recipesDetail.id)
                }
              >
                {itemVariant.map(item => (
                  <option
                    key={item.value}
                    value={item.value}
                    hidden={
                      recipesForm &&
                      item.value === 'Variant Option' &&
                      recipesForm.item_id
                    }
                    disabled={item.isDisable}
                    selected={
                      recipesForm && item.value === recipesForm.item_variant_id
                    }
                    className={
                      recipesForm &&
                      item.is_recipe &&
                      item.value !== recipesForm.item_variant_id &&
                      'is_recipe'
                    }
                  >
                    {item.name}
                  </option>
                ))}
              </Field>
            )}
          </div>
          <LabelSection title="RECIPE" />
          {recipesForm && (
            <div className="mb-20px">
              <FieldArray
                name="recipe_ingredients"
                component={renderFieldArrayIngredients}
                dispatch={this.props.dispatch}
                recipeIngredients={recipesForm.recipe_ingredients}
              />
            </div>
          )}
          <div className="form-group">
            {
              <button
                className={`btn btn-primary ${styles['btn-addIngredients']}`}
                onClick={this._onClickAddIngredients}
              >
                Add Ingredient
              </button>
            }
          </div>
          {recipesDetail && (
            <div className="mb-20px">
              <FieldArray
                name="ingredientsInventory"
                component={renderFieldArrayInventory}
                recipeIngredients={
                  recipesDetail && recipesDetail.recipe_ingredients
                }
              />
            </div>
          )}
        </div>
        <div className={styles['form-footer']}>
          {recipesDetail && recipesDetail.id && (
            <span className="pull-left">
              <button
                className="btn btn-danger no-outline"
                onClick={this._onClickDelete}
                disabled={isSubmittingForm}
              >
                <i className="fa fa-trash" />
              </button>
            </span>
          )}
          {recipesForm && (
            <span className="pull-right">
              <Link
                className={`btn btn-default ${styles['btn-done']} mr-10px`}
                onClick={this._onClickCancel}
                disabled={isSubmittingForm}
              >
                Cancel
              </Link>
              {recipesForm && outlets && outlets.length > 1 && (
                <button
                  className="btn btn-primary no-outline"
                  type="button"
                  style={{ 'margin-right': '10px' }}
                  onClick={handleSubmit(this._onSubmitCreateAllOutlet)}
                  disabled={isSubmittingForm}
                >
                  Save to All Outlets
                </button>
              )}
              {recipesForm && (
                <button
                  className={`btn btn-primary ${styles['btn-done']}`}
                  onClick={handleSubmit(this._onSubmitSave)}
                  disabled={isSubmittingForm}
                >
                  Save
                </button>
              )}
            </span>
          )}
        </div>
        {recipesDetail && recipesDetail.id && (
          <LibraryDeleteModal
            showDeleteModal={showDeleteModal}
            onHide={this._onHideDeleteModal}
            disableHideOnOuterModal
            title="Recipe"
            name={
              !recipesDetail.item_variant_name
                ? recipesDetail.item_name
                : `${recipesDetail.item_name} - ${recipesDetail.item_variant_name}`
            }
            onDelete={this._confirmDelete}
          />
        )}
        <ConfirmSubmitModal />
      </form>
    );
  }

  _onClickCancel = () => {
    this.props.dispatch(recipesFormOnClickCancel());
  };

  _onChangeVariant = (itemVariant, e) => {
    const { dispatch, recipesForm } = this.props;
    change('recipes', 'item_variant_id', e.target.value);
    if (
      e.target.value === 'Variant Option' ||
      e.target.value === 'No Variant'
    ) {
      dispatch(unSetIngredientByItemVariant());
    } else {
      const flagRecipe = { items: [], isRecipe: false };
      itemVariant.map(function(item) {
        if (item.is_recipe) {
          flagRecipe.isRecipe = true;
          flagRecipe.items.push(item);
        }
      });
      if (flagRecipe.isRecipe && flagRecipe.items.length) {
        dispatch(
          setIngredientByItemVariant(
            flagRecipe.items[flagRecipe.items.length - 1],
            recipesForm,
            e.target.value
          )
        );
      }
    }
  };

  _onChangeItemId = (event, outletId) => {
    this.props.dispatch(recipesFormOnChangeOutlet(outletId));
  };

  _onClickAddIngredients = event => {
    event.preventDefault();
    event.stopPropagation();
    const { recipesForm } = this.props;
    this.props.dispatch(onClickAddIngredients(recipesForm.outlet_id));
  };

  _onChangeSelectDropdown = (val, dropdownVal) => {
    const { dispatch, itemsDropdowns, recipesForm } = this.props;
    let selected = null;
    itemsDropdowns.forEach((item, index) => {
      if (dropdownVal === item.value) {
        selected = itemsDropdowns[index];
      }
    });
    if (selected) {
      change('recipes', 'item_name', selected.label);
      dispatch(addItemVariantOnChangeItems(selected, recipesForm));
    }
  };

  _onClickDelete = e => {
    const { dispatch } = this.props;
    dispatch(showDeleteModal());
    e.preventDefault();
    e.stopPropagation();
  };

  _onHideDeleteModal = () => {
    const { dispatch } = this.props;
    dispatch(hideDeleteModal());
  };

  _confirmDelete = () => {
    const { dispatch, recipesDetail, recipes } = this.props;
    dispatch(deleteRecipes(recipesDetail, recipes));
  };

  _onSubmitCreateAllOutlet = values => {
    const { itemVariant } = this.props;
    values.itemVariantTemp = itemVariant;

    if (!values.item_name) {
      if (values.item_id) {
        const itemDropdownObj = this._findItemDropdownById(values.item_id);
        values.item_name = itemDropdownObj.name;
      } else {
        values.item_name = null;
      }
    }
    if (
      !values.item_variant_name &&
      values.item_variant_id &&
      values.item_variant_id !== 'No Variant' &&
      values.item_variant_id !== 'Variant Option'
    ) {
      const itemVariantObj = this._findItemVariantById(values.item_variant_id);
      values.item_variant_name = itemVariantObj.name;
      values.sku = itemVariantObj.sku;
    }
    this.props.onSubmit({
      ...values,
      action: values.id ? 'update_to_all_outlet' : 'save_to_all_outlet',
    });
  };

  _onSubmitSave = values => {
    const { itemVariant } = this.props;
    values.itemVariantTemp = itemVariant;
    if (!values.item_name) {
      if (values.item_id) {
        const itemDropdownObj = this._findItemDropdownById(values.item_id);
        values.item_name = itemDropdownObj.name;
      } else {
        values.item_name = null;
      }
    }
    if (
      !values.item_variant_name &&
      values.item_variant_id &&
      values.item_variant_id !== 'No Variant' &&
      values.item_variant_id !== 'Variant Option'
    ) {
      const itemVariantObj = this._findItemVariantById(values.item_variant_id);
      values.item_variant_name = itemVariantObj.name;
    }
    this.props.onSubmit({ ...values, action: values.id ? 'update' : 'save' });
  };

  _findItemDropdownById = id => {
    const { itemsDropdowns } = this.props;
    return itemsDropdowns.find(function(itemDropdown) {
      if (itemDropdown.id === id) {
        return itemDropdown;
      }
    });
  };

  _findItemVariantById = id => {
    const { itemVariant } = this.props;
    return itemVariant.find(function(item) {
      if (JSON.stringify(item.value) === id) {
        return item;
      }
    });
  };
}

const mapForm = {
  form: 'recipes',
  touchOnBlur: true,
  touchOnChange: true,
  validate,
};

function mapStateToProps(state) {
  const {
    recipes,
    showDeleteModal,
    recipesDetail,
    outlets,
    showAddItemsModal,
    addIngredientsButtonDisabledState,
    itemsDropdowns,
    itemVariant,
    addIngredients,
    isSubmittingForm,
  } = state.ingredients.recipes;
  return {
    recipes,
    showDeleteModal,
    outlets,
    recipesDetail,
    itemVariant,
    showAddItemsModal,
    itemsDropdowns,
    addIngredientsButtonDisabledState,
    search: getFormValues('search')(state),
    recipesForm: getFormValues('recipes')(state),
    addIngredients,
    isSubmittingForm,
  };
}

const connected = connect(mapStateToProps)(reduxForm(mapForm)(RecipesForm));

export default connected;
